
/**
 * This file is auto-generated. Do not modify directly.
 */

/* tslint:disable */
export type DayOfWeekNames = {
  sun: string;
  mon: string;
  tue: string;
  wed: string;
  thu: string;
  fri: string;
  sat: string;
};

export type LocaleDataType = {
  firstDayOfWeek: keyof DayOfWeekNames;
  prefer24HourTimeCycle: boolean;
  narrowDayNames: DayOfWeekNames;
  wideDayNames: DayOfWeekNames;
};

export type LocalizeFormat = {
  localeData: LocaleDataType,
  formatRelativeTime: any,
  formatBestFitRelativeTime: any,
  formatUnit: any,
  formatDate: any,
  formatNumber: any
  parseDate: any,
  parseNumber: any
};
declare const Localize: {msg: any, format: LocalizeFormat};

/* istanbul ignore next */
function getLocalize() {
  if (typeof Localize === 'undefined') {
    throw Error('The messages.<locale>.js file has not been loaded');
  }
  return Localize;
};

/* istanbul ignore next */
export let getLocalizeFormat = () => {
  const localize = getLocalize();
  if (localize.format === undefined) {
    throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
  }
  return localize.format;
};

/* istanbul ignore next */
export const LocaleData = { get: () => getLocalizeFormat().localeData };
const t = (k: string, a?: any): string => getLocalize().msg.formatMessage(k, a);
export const Messages = {
  AddATag: () => t('@tableau__vizportalclient-common-components/AddATag'),
  Save: () => t('@tableau__vizportalclient-common-components/Save'),
  Cancel: () => t('@tableau__vizportalclient-common-components/Cancel'),
};
